import { useMemo } from "react";
import styles from "./TransactionHistoryTable.module.css";
import type { CashierTransactionHistorySavedPaymentAccount } from "@/api/cashier";

/* TransactionHistorySavedPaymentDetails component for rendering saved payment account details.
  @param savedPaymentAccountData - Optional object containing saved payment account details.
  @returns A ReactElement representing the TransactionHistorySavedPaymentDetails component.
*/
export const TransactionHistorySavedPaymentDetails = ({
  savedPaymentAccountData,
}: {
  savedPaymentAccountData?: CashierTransactionHistorySavedPaymentAccount;
}) => {
  const savedPaymentDetails = useMemo(() => {
    const detail = savedPaymentAccountData?.detail;
    const logo = savedPaymentAccountData?.logo_url;
    const name = savedPaymentAccountData?.name;
    if (!(detail || name) || !logo) {
      return null;
    }

    return { detail, logo, name };
  }, [
    savedPaymentAccountData?.detail,
    savedPaymentAccountData?.logo_url,
    savedPaymentAccountData?.name,
  ]);

  if (!savedPaymentDetails) {
    return null;
  }

  return (
    <div className={styles.savedPaymentDetails}>
      <span className={styles.iconContainer}>
        <img alt="Saved payment method logo" src={savedPaymentDetails.logo} />
      </span>
      <span>{savedPaymentDetails.detail || savedPaymentAccountData?.name}</span>
    </div>
  );
};
